import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choose-documents',
  templateUrl: './choose-documents.component.html',
  styleUrls: ['./choose-documents.component.css']
})
export class ChooseDocumentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
